export default "__VITE_ASSET__Cp67lu5Z__"